import { render, staticRenderFns } from "./VipCard.vue?vue&type=template&id=c7480db2&scoped=true&"
import script from "./VipCard.vue?vue&type=script&lang=js&"
export * from "./VipCard.vue?vue&type=script&lang=js&"
import style0 from "./VipCard.vue?vue&type=style&index=0&id=c7480db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7480db2",
  null
  
)

export default component.exports